export default __webpack_public_path__ + "static/media/business-26a.a92a7a4c.jpg";